import { Link } from 'react-router-dom';
import { pillarArticles } from '@/mocks/articles';

export default function PillarArticles() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
              In-Depth Guides
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-4">
              Basetao Spreadsheet Knowledge Center
            </h2>
            <p className="text-sm text-foreground-600 max-w-xl mx-auto">
              Explore our pillar articles covering every aspect of Basetao spreadsheets — from templates to shipping calculators
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {pillarArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/${article.slug}`}
                className="group bg-background-100 rounded-lg border border-background-200/60 p-5 hover:border-accent-300 hover:bg-accent-50/20 transition-all duration-200 cursor-pointer flex flex-col"
              >
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-9 h-9 rounded-lg bg-accent-100 text-accent-600 flex items-center justify-center flex-shrink-0">
                    <i className="ri-article-line text-base"></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <span className="inline-block px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-1.5">
                      {article.badge}
                    </span>
                    <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-accent-700 transition-colors leading-snug line-clamp-2">
                      {article.title}
                    </h3>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1 line-clamp-3">
                  {article.metaDescription}
                </p>
                <div className="flex items-center gap-1.5 text-xs font-medium text-accent-600 group-hover:text-accent-700 transition-colors mt-auto">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}